import { createReducer, on } from '@ngrx/store';
import * as DataDictionaryActions from './data-dictionary.actions';
import { DataDictionaryItem } from '../../components/data-dictionary/data-dictionary.component';

export const dataDictionaryFeatureKey = 'dataDictionary';

export interface DataDictionaryState {
  items: Array<DataDictionaryItem>;
  title: string;
  tabTitle?: string; // Optional, used for tab titles
  tabIcon?: string; // Optional, used for tab icons
}

export const initialState: DataDictionaryState = {
  items: [],
  title: 'Data Dictionary',
  tabTitle: null,
  tabIcon: null
};

export const dataDictionary = createReducer(
  initialState,

  on(DataDictionaryActions.RestoreState, (state, action) => {
    return { ...action.state };
  }),

  on(DataDictionaryActions.ClearState, (state, action) => {
    return { ...initialState };
  }),

  on(DataDictionaryActions.SetDataDictionary, DataDictionaryActions.OpenDataDictionary, (state, action) => {
    return {
      items: action.items,
      title: action.title,
      tabTitle: action.tabTitle,
      tabIcon: action.tabIcon
    };
  })
);

export const dataDictionaryReducer = (state: DataDictionaryState | undefined, action: any) => {
  return dataDictionary(state, action);
};
